import Vue from 'vue';
import VisitService from '@/services/VisitService';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    call: null,
    additionalVisitors: [],
    visitorsFirstCall: false,
  },
  getters: {},
  mutations: {
    SET_CALL(state, value) {
      state.call = value;
    },
    SET_ADDITIONAL_VISITORS(state, value) {
      state.additionalVisitors = value;
    },
    SET_VISITORS_FIRST_CALL(state, value) {
      state.visitorsFirstCall = value;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async getCall({ commit, state, dispatch }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await VisitService.getSingleVisit(id).then(res => {
        const call = res.data;
        commit('SET_CALL', call);

        dispatch('getAdditionalVisitors', id);

        return call;
      }).catch(() => {
        Vue.$toast.error('Something went wrong fetching that visit, please check your connection and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
    async getAdditionalVisitors({ commit, state }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await AdditionalVisitorsService.getAdditionalVisitorsForVisit(id).then(res => {
        let visitors = [...res.data];

        visitors = visitors.map(person => {
          return {
            fullName: `${person.firstname} ${person.lastname}`,
            birthDateAndAge: `${moment(person.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(person.dob, 'years')})`,
            under18: parseInt(moment(new Date()).diff(person.dob, 'years'), 10) < 18,
            ...person
          };
        });

        commit('SET_ADDITIONAL_VISITORS', visitors);

        return visitors;
      }).catch(() => {
        Vue.$toast.error('Something went wrong fetching the additional participants, please check your connection and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
    async getAdditionalVisitorsForProfile({ commit, state }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await AdditionalVisitorsService.getAdditionalVisitors(id).then(res => {
        let visitors = [...res.data];

        visitors = visitors.map(person => {
          return {
            fullName: `${person.firstname} ${person.lastname}`,
            birthDateAndAge: `${moment(person.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(person.dob, 'years')})`,
            under18: parseInt(moment(new Date()).diff(person.dob, 'years'), 10) < 18,
            ...person
          };
        });

        commit('SET_ADDITIONAL_VISITORS', visitors);

        return visitors;
      }).catch(() => {
        Vue.$toast.error('Something went wrong fetching the additional participants, please check your connection and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
    setVisitorsFirstCall({ commit }, value) {
      commit('SET_VISITORS_FIRST_CALL', value);
    },
  },
};
